// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-no-results-wrapper{display:flex;align-items:center;justify-content:center;border:none;height:245px}`, "",{"version":3,"sources":["webpack://./src/components/common/listWrapper/style.scss"],"names":[],"mappings":"AAEA,yBAEI,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,WAAA,CACA,YAAA","sourcesContent":["@import '../../../styles/_globals.scss';\n\n.list-no-results-wrapper {\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    height: 245px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listNoResultsWrapper": `list-no-results-wrapper`
};
export default ___CSS_LOADER_EXPORT___;
